<template>
  <div>
    <h1>Inne alkohole</h1>
    <hr />
    <tiles
      v-bind:query="this.$route.params.query"
      preQuery="a:a5"
      v-bind:displayedCategories="['c', 'b', 'd']"
      routeName="kategorieInne"
      breadcrumbTitle="Wybrałeś / Wybrałaś Inne:"
    ></tiles>
    <foot></foot>
  </div>
</template>

<script>
import Tiles from "./Tiles";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    tiles: Tiles,
    foot: Footer
  },

  beforeRouteUpdate(to, from, next) {
    console.log(`tiles beforeRouteUpdate: ${to.params.query} `);
    next();
  }
};
</script>
